import { render, staticRenderFns } from "./ProductTicket.vue?vue&type=template&id=34452be6&scoped=true&"
import script from "./ProductTicket.vue?vue&type=script&lang=js&"
export * from "./ProductTicket.vue?vue&type=script&lang=js&"
import style0 from "./ProductTicket.vue?vue&type=style&index=0&id=34452be6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34452be6",
  null
  
)

export default component.exports